import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=bb89f272"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=bb89f272&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports